var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#545f7e;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-546 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(546 299)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(532.047 302)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.6 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M132.412,133.539l.007-.007a.28.28,0,0,0,.029-.04s0-.007.007-.011.018-.029.026-.044a.013.013,0,0,1,0-.007c.007-.015.015-.029.022-.048s0,0,0-.007.011-.033.018-.051,0-.007,0-.007a.257.257,0,0,0,.011-.051.033.033,0,0,1,0-.018c0-.015,0-.029.007-.044a.535.535,0,0,0,0-.125.184.184,0,0,0-.007-.044.033.033,0,0,0,0-.018c0-.018-.007-.033-.011-.051s0-.007,0-.007a.288.288,0,0,0-.018-.051s0,0,0-.007-.015-.033-.022-.048a.013.013,0,0,0,0-.007.274.274,0,0,0-.026-.044s0-.007-.007-.011a.383.383,0,0,0-.029-.04l-.007-.007a.524.524,0,0,0-.044-.048l-3.634-3.63a.631.631,0,0,0-.893.893l2.557,2.557H120.232a.63.63,0,1,0,0,1.26H130.4l-2.539,2.539a.63.63,0,1,0,.889.893l3.612-3.612C132.383,133.568,132.4,133.553,132.412,133.539Z",
    transform: "translate(-115.852 -124.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.021,1.26h4.7a.63.63,0,1,0,0-1.26h-4.7A3.426,3.426,0,0,0,17.6,3.421V14.579A3.426,3.426,0,0,0,21.021,18h4.626a.63.63,0,1,0,0-1.26H21.021a2.164,2.164,0,0,1-2.16-2.16V3.421A2.164,2.164,0,0,1,21.021,1.26Z",
    transform: "translate(-17.6 0)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.d01136fe31ed19670dc8aecccc556be7.svg";
export { ForwardRef as ReactComponent };